<template>
  <el-container class="con">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="logo">智慧工地云服务平台</div>
        <div class="nav-links">
          <a href="/"
             class="nav-link">首页</a>
          <!-- 解决方案下拉菜单 -->
          <div class="nav-link dropdown"
               @mouseenter="showDropdown('solution')"
               @mouseleave="hideDropdown('solution')">
            核心能力
            <div class="dropdown-menu"
                 :class="{ 'show': solutionDropdownVisible }">
              <a href="/coreTechnology"
                 class="dropdown-item">BIM轻量化引擎</a>
              <a href="/talentManage"
                 class="dropdown-item">数字孪生&IoT</a>
              <a href="/AI"
                 class="dropdown-item">AI应用</a>
            </div>
          </div>
          <!-- 产品中心下拉菜单 -->
          <div class="nav-link dropdown"
               @mouseenter="showDropdown('product')"
               @mouseleave="hideDropdown('product')">
            解决方案
            <div class="dropdown-menu"
                 :class="{ 'show': productDropdownVisible }">
              <a href="/peopleSystem"
                 class="dropdown-item">人员实名制方案</a>
              <a href="/secure"
                 class="dropdown-item">安全管理方案</a>
              <a href="/greenProject"
                 class="dropdown-item">绿色工程方案</a>
              <a href="/bim"
                 class="dropdown-item">进度可视化方案</a>
            </div>
          </div>
          <a href="/industryEmpower"
             class="nav-link">成功案例</a>
          <a href="/aboutUs"
             class="nav-link">关于我们</a>
        </div>
        <div class="contact-btn">
          <button @click="scrollToBottom">联系我们</button>
        </div>
      </div>
    </nav>
    <el-main>
      <router-view class="main" />
      <floating-contact-bar></floating-contact-bar>
    </el-main>
    <!-- 二维码模态框 -->
    <div v-if="showQrModal"
         class="qr-modal">
      <div class="qr-modal-content">
        <img src="./assets/img/wxerweima.jpg"
             alt="二维码">
        <p>联系我们预约体验</p>
        <button class="close-btn"
                @click="showQrModal = false">关闭</button>
      </div>
    </div>
    <div>

    </div>
    <el-footer :style="{ opacity: footerVisible,background:footColor }">
      <div class="footerTop">
        <div class="
           weChat">
          <p>
            <img :src="aboutUs_9"
                 alt />
          </p>
          <p>
            <img :src="aboutUs_8"
                 alt />
          </p>
          <p>关注玖亘科技官方公众号</p>
        </div>
        <div class="callUs">
          <p>联系我们：</p>
          <p>玖亘（北京）科技发展有限公司</p>
          <p>公司地址：</p>
          <p>北京市大兴区市场东巷2号后院3层</p>
          <p>
            <span @click="showQrCodeModal">快速体验</span>
            <span @click="toRouter">公司简介</span>
          </p>
        </div>
        <div class="email">
          <p>邮箱：</p>
          <p>ibstd@jiugen.net</p>
          <p>咨询热线：</p>
          <p>186 0064 6605</p>
          <p>周一至周五 9:00 - 18:30</p>
        </div>
      </div>
      <div class="footerBot">京ICP备2023013029号-2</div>
    </el-footer>
  </el-container>
</template>

<script>
import FloatingContactBar from './components/FloatingContactBar.vue'
export default {
  components: {
    FloatingContactBar
  },
  data () {
    return {
      logo: require("@/assets/img/logo.png"),
      aboutUs_8: require("@/assets/img/aboutUs_8.png"),
      aboutUs_9: require("@/assets/img/aboutUs_9.png"),
      solutionDropdownVisible: false,
      productDropdownVisible: false,
      showQrModal: false,
      footerVisible: 0,
      footColor: "#ffffff00",
    };
  },
  mounted () {

    // 添加定时器，延迟2秒显示footer
    setTimeout(() => {
      this.footerVisible = 1;
      this.footColor = "#0d28af"
    }, 2000); // 2000毫秒 = 2秒
    function isMobile () {
      if (
        window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return true; // 移动端
      } else {
        return false; // PC端
      }
    }
    if (isMobile()) {
      location.href = "http://mobile.jiugen.net";
      // 判断true跳转到这个主页
    }
  },
  methods: {
    toRouter () {
      this.$router.push('/aboutUs')
      window.scrollTo({
        top: 500,
        behavior: 'smooth'
      });
    },
    showQrCodeModal () {
      this.showQrModal = true;
    },
    showDropdown (type) {
      if (type === 'solution') {
        this.solutionDropdownVisible = true;
      } else if (type === 'product') {
        this.productDropdownVisible = true;
      }
    },
    scrollToBottom () {
      const scrollElement = document.documentElement || document.body;
      const targetPosition = scrollElement.scrollHeight;
      const startPosition = scrollElement.scrollTop;
      const distance = targetPosition - startPosition;
      const duration = 800; // 动画持续时间（毫秒）
      let startTime = null;

      // 动画函数
      const animation = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        // 使用ease-out缓动函数
        const easeOutQuad = progress * (2 - progress);
        scrollElement.scrollTop = startPosition + distance * easeOutQuad;

        if (timeElapsed < duration) {
          requestAnimationFrame(animation);
        }
      };

      requestAnimationFrame(animation);

    },
    hideDropdown (type) {
      if (type === 'solution') {
        this.solutionDropdownVisible = false;
      } else if (type === 'product') {
        this.productDropdownVisible = false;
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/* 二维码模态框样式 */
.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}

.qr-modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}

.qr-modal-content img {
  width: 200px;
  height: 200px;
  margin-bottom: 10px;
}

.qr-modal-content p {
  margin-bottom: 20px;
}

.close-btn {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.close-btn:hover {
  background-color: #0069d9;
}
.con {
  text-align: center;
  box-sizing: border-box;
  /deep/ .el-footer {
    height: 490px !important;
    background: #ffffff00;
    color: #e6eaff;
    padding: 0;
    .footerTop {
      height: 420px;
      display: flex;
      padding-top: 62px;
      box-sizing: border-box;
      .weChat {
        width: 206px;
        height: 330px;
        text-align: left;
        border-right: 1px solid #2e4ff3;
        padding-right: 104px;
        margin-left: 400px;
        :nth-child(1) {
          img {
            width: 150px;
            height: 52px;
          }
        }
        :nth-child(2) {
          margin-top: 30px;
          margin-bottom: 20px;
          img {
            width: 204px;
            height: 204px;
          }
        }
        :nth-child(3) {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
        }
      }
      .callUs {
        width: 490px;
        height: 330px;
        text-align: left;
        margin-left: 40px;
        border-right: 1px solid #2e4ff3;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #e6eaff;
        :nth-child(1) {
          margin-bottom: 20px;
        }
        :nth-child(2) {
          margin-bottom: 50px;
        }
        :nth-child(3) {
          margin-bottom: 20px;
        }
        :nth-child(4) {
          margin-bottom: 52px;
        }
        :nth-child(5) {
          :nth-child(1),
          :nth-child(2) {
            display: inline-block;
            width: 168px;
            height: 53px;
            border: 2px solid #9aaaff;
            border-radius: 8px;
            text-align: center;
            line-height: 53px;
            cursor: pointer;
          }
          :nth-child(1) {
            margin-right: 20px;
          }
        }
      }
      .email {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #e6eaff;
        text-align: left;
        margin-left: 41px;
        :nth-child(1) {
          margin-bottom: 22px;
        }
        :nth-child(2) {
          margin-bottom: 48px;
        }
        :nth-child(3) {
          margin-bottom: 22px;
        }
        :nth-child(4) {
          font-size: 30px;
          margin-bottom: 23px;
        }
      }
    }
    .footerBot {
      height: 70px;
      line-height: 70px;
      text-align: center;
      border-top: 1px solid #2e4ff3;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #e6eaff;
    }
  }
}
/deep/.el-header {
  height: 56px !important;
  position: fixed;
}
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.logo {
  margin-top: 13px;
  img {
    width: 90px;
    height: 32px;
  }
}
.menu {
  margin-right: 227px;
}
.el-header {
  display: flex;
  justify-content: space-between;
}
.el-main {
  padding: 0;
  overflow: hidden;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
  .el-menu-item {
    height: 50px;
  }
}
.el-dropdown-menu__item,
.el-menu-item {
  padding: 0;
  margin: 0 20px 0 20px !important;
  font-size: 16px;
}
.el-menu-item:hover {
  outline: 0 !important;
  border-bottom: 2px solid #0165ff !important;
  color: #0165ff !important;
}
/* 导航栏样式 */
.navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  height: 88px;
  z-index: 50;
  transition: all 0.5s ease;
}

.navbar.scrolled {
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.container {
  // max-width: 1200px;
  // margin: 0 auto;
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 36px;
  font-weight: bold;
  color: white;
  margin-bottom: 15px;
}

.navbar.scrolled .logo {
  color: #333;
}

.nav-links {
  display: flex;
  gap: 30px;
  margin-left: 407px;
  // margin-right: 281px;
}

.navbar.scrolled .nav-link {
  color: #333;
}
.nav-link {
  font-size: 20px !important;
  color: #fff;
  display: inline-block;
  line-height: 88px;
  position: relative;
  text-align: center;
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}
.nav-link::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #1a73e8;
  transition: width 0.3s ease;
}
.nav-link:hover::before {
  width: 100%;
}
.nav-link:hover {
  color: #1a73e8;
}

.contact-btn button {
  background-color: #1a73e8;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-right: 500px;
}

.contact-btn button:hover {
  background-color: #0d47a1;
}

/* 下拉菜单样式 */
.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px;
  width: 150px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu a {
  display: block;
  color: #333;
  text-decoration: none;
  padding: 5px 0;
  position: relative;
}

.dropdown-menu a:hover {
  color: #1a73e8;
}

/* 二级菜单下划线效果 */
.dropdown-item {
  position: relative;
  padding: 5px 0;
  display: block;
  text-decoration: none;
  color: #333;
}

.dropdown-item::after {
  content: "";
  position: absolute;
  width: 0;
  height: 1px;
  bottom: 2px;
  left: 0;
  background-color: #1a73e8;
  transition: width 0.3s ease;
}

.dropdown-item:hover::after {
  width: 100%;
}
</style>